import React from 'react';
import UserCard from '../UserCard';
import account_circle from '../../assets/account_circle-24px-light-gray.svg';
import styles from './styles.module.scss';
import useDropdownMenu from 'react-accessible-dropdown-menu-hook';

const MenuItemUser = () => {
  const {buttonProps, isOpen} = useDropdownMenu(1);

  return (
    <div className={styles.MenuItemUserContainer}>
      <div {...buttonProps} className={styles.labelContainer}>
        <img src={account_circle} alt="account" className={styles.account}/>
        <span className={styles.label}>משתמש</span>
      </div>
      <div className={isOpen ? styles.visible : styles.hidden} role='menu'>
        <UserCard />
      </div>
    </div>
  );
};

export default MenuItemUser;
